import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { PulseLoaderComponent } from './pulse-loader.component';

@NgModule({
  declarations: [
    PulseLoaderComponent,
  ],
  exports: [
    PulseLoaderComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class PulseLoaderModule { }
